import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import CommentSection from './CommentSection';
import FollowButton from './FollowButton';
import './PostCard.css';

function PostCard({ post, onDelete, onFollowChange }) {
  const { user: currentUser } = useAuth();
  const [localPost, setLocalPost] = useState(post);
  const [showComments, setShowComments] = useState(false);

  const handleLike = async () => {
    try {
      await axios.post(`/api/likes/post/${localPost.id}/like`);
      const response = await axios.get(`/api/posts/${localPost.id}`);
      setLocalPost(response.data);
    } catch (error) {
      console.error('Error liking post:', error);
    }
  };

  const handleDislike = async () => {
    try {
      await axios.post(`/api/likes/post/${localPost.id}/dislike`);
      const response = await axios.get(`/api/posts/${localPost.id}`);
      setLocalPost(response.data);
    } catch (error) {
      console.error('Error disliking post:', error);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await axios.delete(`/api/posts/${localPost.id}`);
        onDelete(localPost.id);
      } catch (error) {
        console.error('Error deleting post:', error);
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
  };

  const authorDisplayName = localPost.fullName || localPost.username || 'User';

  return (
    <div className="post-card">
      <div className="post-header">
        <Link to={`/profile/${localPost.userId}`} className="post-author">
          <div className="author-avatar">
            {authorDisplayName.charAt(0).toUpperCase()}
          </div>
          <div>
            <div className="author-name">{authorDisplayName}</div>
            <div className="post-time">{formatDate(localPost.createdAt)}</div>
          </div>
        </Link>

        <div className="post-header-actions">
          <FollowButton
            userId={localPost.userId}
            currentUserId={currentUser?.userId}
            onFollowChange={onFollowChange}
            size="small"
          />
        </div>
      </div>

      {localPost.content && (
        <div className="post-content">
          {localPost.content}
        </div>
      )}

      {localPost.linkUrl && (
        <a href={localPost.linkUrl} target="_blank" rel="noopener noreferrer" className="article-preview">
          {localPost.linkImage && (
            <img src={localPost.linkImage} alt="" className="article-preview-image" />
          )}
          <div className="article-preview-body">
            <div className="article-preview-title">{localPost.linkTitle || localPost.linkUrl}</div>
            {localPost.linkDescription && (
              <div className="article-preview-description">{localPost.linkDescription}</div>
            )}
          </div>
        </a>
      )}

      <div className="post-actions">
        <button
          className={`action-btn ${localPost.isLikedByCurrentUser ? 'active' : ''}`}
          onClick={handleLike}
        >
          👍 {localPost.likeCount}
        </button>

        <button
          className={`action-btn ${localPost.isDislikedByCurrentUser ? 'active' : ''}`}
          onClick={handleDislike}
        >
          👎 {localPost.dislikeCount}
        </button>

        <button
          className="action-btn"
          onClick={() => setShowComments(!showComments)}
        >
          💬 {localPost.commentCount}
        </button>

        <button className="action-btn" onClick={handleDelete}>
          🗑️
        </button>
      </div>

      {showComments && (
        <CommentSection
          postId={localPost.id}
          onCommentAdded={() => {
            setLocalPost({...localPost, commentCount: localPost.commentCount + 1});
          }}
        />
      )}
    </div>
  );
}

export default PostCard;
